module.exports = __webpack_public_path__ + "static/media/AtlasGrotesk-RegularItalic-Cy-Web.3920ebb4.woff";